<template>
  <div class="return-visit">
        <van-search v-model="searchValue" @search="onSearch"  left-icon show-action placeholder="输入患者姓名" >
            <template #action>
            <div @click="onSearch"><van-icon name="search" size='20' /></div>
            </template>
        </van-search>

        <van-dropdown-menu active-color="#0AA8AF">
            <van-dropdown-item :title="title1" v-model="value1" :options="option1" @change="changeStutas1" />
            <van-dropdown-item :title="title2" v-model="value2" :options="option2" @change="changeStutas2" class="dropdown2" :disabled="menuDisabled2"/>
        </van-dropdown-menu>


        <van-list v-model="loading" :finished="finished" @load="onLoad" >
            <van-cell-group inset class="cell-group" v-for="item,index in list" :key="index">
                <div class="info_card">
                    <van-row type="flex" gutter="20">
                        <van-col span="12"><div class="info_item"><div class="label">患者姓名:</div> <div class="info_value">{{item.patient_name}}</div></div></van-col>
                        <van-col span="12"><div class="info_item"> <div class="label">省份城市</div> <div class="info_value">{{item.province}}{{item.city}}</div></div></van-col>
                    </van-row>
                    <van-row type="flex" gutter="20">
                        <van-col span="12"><div class="info_item"><div class="label">联系电话:</div> <div class="info_value">{{item.mobile}}</div></div></van-col>
                        <van-col span="12"><div class="info_item"><div class="label">领药时间:</div> <div class="info_value">{{item.receive_date}}</div></div></van-col>
                    </van-row>
                    <van-row type="flex" gutter="20">
                        <van-col span="12"><div class="info_item"><div class="label">领药阶段:</div> <div class="info_value">{{item.phase}}</div></div></van-col>
                        <van-col span="12"><div class="info_item"><div class="label">领药次数:</div> <div class="info_value">{{item.receive_times}}</div></div></van-col>
                    </van-row>
                    <van-row type="flex" gutter="20">
                        <van-col span="12"><div class="info_item"><div class="label">药房名称:</div> <div class="info_value">{{item.drugstore_name}}</div></div></van-col>
                        <van-col v-if="item.vist_finished=='1'" span="12" ><div class="info_item"><div class="label">回访时间:</div> <div class="info_value">{{item.vist_date}}</div></div></van-col>
                    </van-row>
                    <van-row type="flex" gutter="20">
                        <van-col v-if="item.continue" span="12"><div class="info_item"><div class="label">是否用药:</div> <div :class="item.continue == '延迟用药' ? 'info_value_tip' : 'info_value'">{{item.continue}}</div></div></van-col>
                        <van-col v-if="item.vist_finished=='1'" span="12"><div class="info_item"><div class="label">援助药品的用药时间：:</div> <div class="info_value">{{item.cyle_drug_use_date}}</div></div></van-col>
                    </van-row>
                    <van-row type="flex" gutter="20" v-if="item.continue=='已用药'">
                        <van-col span="24"><div class="info_item" v-if="item.patient_vist_images">
                            <div class="label">上传用药凭证</div> 
                            <div class="info_value"><van-image v-for="img,index in item.patient_vist_images" :key="index" width="10rem" height="10rem"  fit="contain" :src="img"/></div></div>
                        </van-col>
                        <van-col span="24"><div class="info_item"><div class="label">请提醒患者下次领药材料和领药时间点；</div> </div></van-col>
                    </van-row>
                    <van-row type="flex" gutter="20" v-if="item.continue=='延迟用药'">
                        <van-col span="24"><div class="info_item"><div class="tip_text">1.请提醒患者注意药品存储要求，并且尽快用药；</div><div class="tip_text">2.下次仍需要对患者进行回访（5天内）；</div> </div></van-col>
                    </van-row>
                    <van-row type="flex" gutter="20" v-if="item.continue=='未用药'">
                        <van-col span="24"><div class="info_item"><div class="label">其他原因:</div> <div class="info_value">xxx</div></div></van-col>
                        <van-col span="24"><div class="info_item"><div class="label">请提醒患者药品退回到项目药房;</div> </div></van-col>
                    </van-row>
                </div>
                <div class="checkin-btn" v-if="item.vist_finished=='0'">
                    <van-button type="primary" round color="#0AA8AF" @click="returnVisit(item.receive_id)" block>回访</van-button>
                </div>
            </van-cell-group>

            <template #finished>
                <van-divider :style="{ color: '#bababa', borderColor: '#bababa', padding: '0 80px'}">
                    <div style="width:3px;height:3px;border-radius:100%;background-color:#bababa;"></div>
                </van-divider>
            </template>
        </van-list>

  </div>
</template>

<script>
import Vue from 'vue';
import { List,Toast,Divider,DropdownMenu, DropdownItem} from 'vant';
import { getPatientVistList } from '@/api/publicWelfareStaff';
import { mapState } from "vuex";

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Divider);
Vue.use(List);
Vue.use(Toast);
export default {
    data(){
        return {
            searchValue: '',
            
            //无限加载列表
            list: [],
            list_copy: [],
            loading: false,
            finished: false,
            value1: '', //回访状态
            value2: '',//用药状态
            title1:'回访状态', 
            title2:'用药状态',
            option1: [
                { text: '待回访', value: '2' },
                { text: '已回访', value: '1' },
            ],
            option2: [
                { text: '已用药', value: '已用药' },
                { text: '延迟用药', value: '延迟用药' },
                { text: '未用药', value: '未用药' },
            ],

            page:1,
            stop:false,

            menuDisabled2:false,//禁用第二个下拉菜单选项

        }
    },
        computed: {
        ...mapState(['publicWelfareStaff']),
    },    
    async created(){
      await this.init()
        //   this.showPage=true;
    },
    methods: {
      async init(){

      },
      // 用药状态     status            已用药，延迟用药，未用药
      // 回访状态     vist_finished     0:待回访，1:已回访
      // 患者姓名     keyword           string
      //查询接口
      async fetchData(status,vist_finished,keyword,page){
        let data=[]
        let sendData={
          keyword:keyword,
          status:status,
          vist_finished:vist_finished,
          page:page,
          volunteer_id:this.publicWelfareStaff.checkin_info.papid
        }
        if(!status) delete sendData.status
        if(!vist_finished) delete sendData.vist_finished
        if(!keyword) delete sendData.keyword
        await getPatientVistList(sendData).then(res=>{
          console.log("getPatientVistList",res)
          this.list=[...this.list,...res.data]
          data=res.data
        }).catch(error=>{
          Toast(err.response.data.message)
        })
        return data
      },
        async changeStutas1(value){
            if(this.stop==true) return
            Toast.loading({
                duration: 0, // 持续展示 toast
                overlay: true,
                forbidClick: true
            });
            console.log("回访状态",value)
            this.value1=value
            this.title1=value==2?"待回访":"已回访"
            this.searchValue=''
            this.page=1
            this.list=[]
            if(this.title1=="待回访") {
                this.value2=''
                this.title2='用药状态'
                this.menuDisabled2=true
            }else{
                this.menuDisabled2=false
            }
            await this.fetchData(this.value2,this.value1,this.searchValue,this.page)
            this.page++
            this.finished = false;
            Toast.clear();
        },
        async changeStutas2(value){
            if(this.stop==true) return
            Toast.loading({
                duration: 0, // 持续展示 toast
                overlay: true,
                forbidClick: true
            });
            console.log("用药状态",value)
            this.value2=value
            this.title2=value
            this.searchValue=''
            this.page=1
            this.list=[]
            await this.fetchData(this.value2,this.value1,this.searchValue,this.page)
            this.page++
            this.finished = false;
            Toast.clear();
        },
      async onSearch(value){
          if(this.stop==true) return
        Toast.loading({
                duration: 0, // 持续展示 toast
                overlay: true,
                forbidClick: true
            });
        console.log("搜索的值",this.searchValue)
        this.page=1
        this.list=[]
       await this.fetchData(this.value2,this.value1,this.searchValue,this.page)
       this.page++
       this.finished = false;
       Toast.clear();
      },
      async onLoad() {
        // 异步更新数据
        this.stop=true;
            await this.fetchData(this.value2,this.value1,this.searchValue,this.page).then(res=>{
              console.log("fetchData",res)
              if (res.length>0) this.page++

              // 加载状态结束
              this.loading = false;

              // 数据全部加载完成
              if (res.length==0) {
                  this.finished = true;
              }
            })

        this.stop=false
      },
      returnVisit(receive_id){
        // 新增记录
        console.log("回访")
        this.$router.push({name:'visitDetail',query:{
            receive_id:receive_id
        }})
      }
    }
}
</script>

<style lang="scss" scoped>
.return-visit{
    min-height: 100vh;
    background-color: #F9F9F9 ;
    font-size: 16px;
    ::v-deep .dropdown2{
        div.van-dropdown-item__option:nth-child(2){
            .van-cell__title{
                span{
                    // color:red;
                }
            }
        }
    }
    //下拉菜单
    ::v-deep .van-dropdown-item__option{
        .van-cell__title{
            display: flex !important;
            justify-content:center;
            flex:10;
        }
        .van-cell__value{
            display:none;
        }
    }
    //去掉下拉框的shadow
    ::v-deep .van-dropdown-menu{
        margin-bottom: 16px;
        .van-dropdown-menu__bar {
            box-shadow: none;
        }
    }
    .checkin-btn {
        margin:  0 15px 15px 15px;
    }

    //回访信息卡片
    .van-cell-group {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    .cell-group{
        margin-bottom:10px;
        .info_card{
            padding:15px;
            .info_item{
                display: flex;
                flex-direction: column;
                margin-bottom: 10px;
                .label{
                    color: #848484;
                    font-size:14px;
                }
                .tip_text{
                    color:#FF0000;
                    font-size:14px;
                }
                .info_value{
                    color:#333333;
                    font-size: 15px;
                }
                .info_value_tip{
                    color:#FF0000;
                    font-size: 15px;
                }
            }
        }
        
        .van-cell__title {
            flex: 1;
            text-align: right;
            margin-right: 10px;
        }
        .van-cell__value{
            flex: 3;
            color:black;
            white-space:nowrap;
            text-align: left;
            // display:flex;
            // justify-content:flex-start;
            // align-items:center;
        .alignment-flex{
            display:flex;
            justify-content:flex-start;
            align-items:flex-start;
        }
        }
        
      
    }
}
</style>